import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import gifLoading from "../Images/loading.gif";
import * as Yup from "yup";
import { FormHandles } from "@unform/core";
import { InputFileMultiple } from "../Inputs/InputFileMultiple";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { RHFInput } from "../Inputs/RHFInput";
import { RHFAutocomplete } from "../Inputs/RHFAutocomplete";
import { YupSchemas } from "../../utils/yup";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  DivBoxInput,
  DivContainer,
  DivForm,
  DivSelect,
  RadioInputContainer,
  Title1,
  Title2,
  ErrorText,
  InputLabel,
  ButtonSend,
  DivButtonContainer,
} from "./styles";
import api from "../../services/api/index";
import { useProgress } from "../../hooks/progress";
import Estados from "../../utils/Estados/Estados.json";
import Cidades from "../../utils/Cidades/Cidades.json";
import ModalCEP from "../Modais/ModalCEP";
import ModalLink from "../Modais/ModalLink";
import { ModalProgress } from "./ModalProgress";
import ModalConsumoMinimo from "../Modais/ModalConsumoMinimo";

import { readDataStorage } from "../../utils/storage/storage";

import getValidationErrors from "../../utils/getValidationErrors";
import { cpf, cnpj } from "cpf-cnpj-validator";
import {
  IData2DadosBancario,
  IData2Endereco,
  IData2Fatura,
  IData2Form,
  IData2PessoaFisica,
  IData2PessoaJuridica,
  IData2Responsavel,
  IDataRepresentante,
  IDataUsina,
} from "../../@Types";
import Toast from "../Toast/Toast";
import checkIcon from "../Toast/Image/check.svg";
import errorIcon from "../Toast/Image/error.svg";
import { Box, Stack, Tooltip } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
export const GeradorDePropostas = () => {
  const [isGif, setGif] = useState(false);
  const { setLoad } = useProgress();
  const [pessoa, setPessoa] = useState<string>("PF");
  const [media, setMedia] = useState<number>(0);
  const [checkMedia, setCheckMedia] = useState<boolean>(false);
  const [modalIsOpenCEP, setIsOpenCEP] = useState(false);
  const [modalIsOpenLink, setIsOpenLink] = useState(false);
  const [modalIsOpenConsumoMinimo, setIsOpenConsumoMinimo] = useState(false);
  const [linkRep, setLinkRep] = useState("");
  const [calculo, setCalculo] = useState("");
  const [mensalidade, setMensalidade] = useState("");
  const [dataModal, setDataModal] = useState<IData2Form>();
  const [detalhamento, setDetalhamento] = useState();
  const [, /*CEPvalido*/ setCEPvalido] = useState();
  const [defaultEstado, setDefaultEstado] = useState<number>(0);
  const [defaultCity, setDefaultCity] = useState<number>(0);
  const [cidades /*setCidades*/] = useState<any>(Cidades);
  const Ref = useRef<FormHandles>(null);
  const [concessionaria, setConcessionaria] = useState<any>([]);
  const [consorcios, setConsorcios] = useState<any>([]);
  const [usinas, setUsinas] = useState<any>([]);
  const [criUsina, setCriUsina] = useState<any>();
  const [noOptionsTextConcessionaria, setNoOptionsTextConcessionaria] =
    useState<any>("Selecione o estado");
  const [noOptionsTextConsorcio, setNoOptionsTextConsorcio] = useState<any>(
    "Selecione o a concessionária"
  );
  const [propostaDuplicada, setPropostaDuplicada] = useState<boolean>(false);
  const [idCardDuplicado, setIdCardDuplicado] = useState<string>("");
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [mesesPreenchidosDup, setMesesPreenchidosDup] =
    useState<boolean>(false);
  const [modalUcBloqueada, setModalUcBloqueada] = useState(false);
  const [ucBloqueada, setUcBloqueada] = useState(false);
  const [backupPF, setBackupPF] = useState({});
  const [backupPJ, setBackupPJ] = useState({});

  const {
    NomeRepresentante,
    EmailRepresentante,
    CpfRepresentante,
    RazaoRepresentante,
    CnpjRepresentante,
    CodigoLink,
    canal,
    Grupo,
    Gestor1,
    Gestor2,
    Gestor3,
    Origem,
    CodigoPlano,
    Equipe,
    IdCard,
    TipoVendedor,
    Regional,
  } = readDataStorage("login");

  const resolver: Resolver<any> = yupResolver(
    pessoa === "PF"
      ? YupSchemas.register.RegisterDataPF
      : YupSchemas.register.RegisterDataPJ
  );

  const methods = useForm({
    resolver,
  });

  const { reset } = methods;

  const handleOnChangeClass = useCallback(
    (val) => {
      methods.setValue("subgrupo", "");
    },
    [methods]
  );

  const [list, setList] = useState<any>([]);

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "success":
          toastProperties = {
            id,
            title: "",
            description: "Cadastro salvo com sucesso",
            backgroundColor: "#5cb85c",
            icon: checkIcon,
          };
          break;
        case "errorSend":
          toastProperties = {
            id,
            title: "",
            description: "Erro ao deletar fatura",
            backgroundColor: "#D72828",
            icon: errorIcon,
          };
          break;
        case "faturaExcluida":
          toastProperties = {
            id,
            title: "",
            description: "Fatura excluída",
            backgroundColor: "#6C5AF4",
            icon: checkIcon,
          };
          break;
        case "catchListBanks":
          toastProperties = {
            id,
            title: "",
            description: "Falha ao listar bancos",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "catchBuscarCep":
          toastProperties = {
            id,
            title: "",
            description: "Não encontramos o CEP informado",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "catchSalvarRegistro":
          toastProperties = {
            id,
            title: "",
            description: "Falha ao Salvar Registro",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "NenhumBanco":
          toastProperties = {
            id,
            title: "",
            description: "Débito automático indisponível para esta UF",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "Limite":
          toastProperties = {
            id,
            title: "",
            description: "Limite de caracteres atingido",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "Sanitize":
          toastProperties = {
            id,
            title: "",
            description: "Caracteres não permitidos. Revise seu e-mail",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "LimiteTamanhoArquivo":
          toastProperties = {
            id,
            title: "",
            description: "Arquivo muito grande !",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "CEP":
          // eslint-disable-next-line
          toastProperties = {
            id,
            title: "",
            description: "Cidade e Estado são alterados somente através do CEP",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;

        case "404Conce":
          toastProperties = {
            id,
            title: "",
            description: "Não há concessionária elegível",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        case "404Consorcio":
          toastProperties = {
            id,
            title: "",
            description: "Nenhuma consórcio encontrado",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        case "404Usina":
          toastProperties = {
            id,
            title: "",
            description: "Nenhuma usina encontrada",
            backgroundColor: "#f0ad4e",
            icon: errorIcon,
          };
          break;
        case "LimiteCaract":
          toastProperties = {
            id,
            title: "",
            description: "Limite de caracteres atingido",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        case "UC-bloqueada":
          toastProperties = {
            id,
            title: "",
            description: "UC bloqueada. Não é possível gerar proposta.",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;
        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  const handleSetModal = useCallback((e) => {
    switch (e) {
      case "OK":
        setIsOpenLink(true);
        break;
      case "Sem proposta":
        setIsOpenConsumoMinimo(true);
        break;
    }
  }, []);

  const alteraCRI = useCallback(
    async (idCard, data) => {
      setLoad(true);

      await api
        .post("/csp/representante/alterar/card", {
          idCard: idCard,
          CRI: data.usina.CRI,
          usina: data.usina.usina,
        })
        .then((res: any) => {
          if (res.status === 200) {
            setLoad(true);
            handleSetModal("OK");
          }
        })
        .catch((err: any) => {
          setLoad(false);
          console.error(err);
          if (err.response.status === 404) {
          }
        });
      setLoad(false);
    },
    [setLoad, handleSetModal]
  );

  function disableInputCep() {
    showToast("CEP");
  }

  const classes = useMemo(
    () => [
      { value: "Monofásico", label: "Monofásico" },
      { value: "Bifásico", label: "Bifásico" },
      { value: "Trifásico", label: "Trifásico" },
    ],
    []
  );

  const grupoTarifario = useMemo(
    () => [
      { value: "Residencial", label: "Residencial" },
      { value: "Comercial", label: "Comercial" },
      { value: "Rural", label: "Rural" },
      { value: "Industrial", label: "Industrial" },
      { value: "Outros", label: "Outros" },
    ],
    []
  );

  const meses = useMemo(
    () => [
      { id: "inputMes1", label: "Jan", value: 0 },
      { id: "inputMes2", label: "Fev", value: 0 },
      { id: "inputMes3", label: "Mar", value: 0 },
      { id: "inputMes4", label: "Abr", value: 0 },
      { id: "inputMes5", label: "Mai", value: 0 },
      { id: "inputMes6", label: "Jun", value: 0 },
      { id: "inputMes7", label: "Jul", value: 0 },
      { id: "inputMes8", label: "Ago", value: 0 },
      { id: "inputMes9", label: "Set", value: 0 },
      { id: "inputMes10", label: "Out", value: 0 },
      { id: "inputMes11", label: "Nov", value: 0 },
      { id: "inputMes12", label: "Dez", value: 0 },
    ],
    []
  );
  const onSanitizeValueDay = useCallback((e: any) => {
    const { value } = e.target;
    let newValue = value.replace(/\D/g, "");
    if (newValue) {
      if (newValue >= 1 && newValue <= 31) {
        e.target.value = value;
        return;
      }
    }
    e.target.value = "";
  }, []);

  const listaConcessionaria = useCallback(
    async (value: any) => {
      setLoad(true);
      await api
        .post("/csp/estadoconce/conce/rep", {
          idCard: IdCard,
          estado: value,
        })
        .then((res: any) => {
          let arrayConcessionarias = [];
          const {
            data: { concessionaria },
          } = res;
          for (const k in concessionaria) {
            const { nome } = concessionaria[k];
            arrayConcessionarias.push({ value: nome, label: nome });
          }
          setConcessionaria(arrayConcessionarias);
        })
        .catch((err: any) => {
          setLoad(false);
          console.error(err);
          if (err.response.status === 404) {
            showToast("404Conce");
            setNoOptionsTextConcessionaria("Não há concessionária elegível");
            setConcessionaria([]);
          } else {
            setNoOptionsTextConcessionaria("Selecione o estado");
            setConcessionaria([]);
          }
        });
      setLoad(false);
    },
    [setLoad, setNoOptionsTextConcessionaria, showToast, IdCard]
  );

  const [isGoias, setIsGoias] = useState(false);
  const [canProceedToInvoiceData, setCanProceedToInvoiceData] = useState(false);

  const handleBlurCEP = useCallback(
    async (value: string) => {
      let cep = value.replace(/\D/g, "");

      setCanProceedToInvoiceData(false);
      setIsGoias(false);
      methods.setValue("numeroInstalacao", "");
      if (cep.length === 8) {
        api
          .get(`/csp/consultacep/cep/${cep}`)
          .then((response: any) => {
            if (response.status === 200) {
              setCEPvalido(response.data.message.valido);
              if (response.data.message.valido === 1) {
                const { message } = response.data;
                listaConcessionaria(message.siglauf);
                setCanProceedToInvoiceData(true);
                if (message) {
                  setIsGoias(message.siglauf === "GO");
                  methods.setValue("enderecoBairro", message.bairro);
                  methods.setValue("enderecoLogradouro", message.logradouro);
                  methods.setValue("enderecoComplemento", message.complemento);
                  methods.setValue("enderecoCidade", message.localidade);
                  methods.setValue("enderecoEstado", message.uf);
                  const indexUf = Estados.map((el: any) => el.id).indexOf(
                    message.uf
                  );
                  if (indexUf !== -1) {
                    setDefaultEstado(indexUf);
                  }
                  const indexCity = cidades
                    .map((el: { label: any }) => el.label)
                    .indexOf(message.localidade);
                  if (indexCity !== -1) {
                    setDefaultCity(indexCity);
                  }
                } else {
                  setDefaultEstado(defaultEstado);
                  setDefaultCity(defaultCity);
                }
              } else {
                setIsOpenCEP(true);
              }
            }
          })
          .catch((err: any) => {
            showToast("catchBuscarCep");
          });
      }
    },
    [
      cidades,
      defaultEstado,
      defaultCity,
      showToast,
      listaConcessionaria,
      methods,
    ]
  );

  const closeModal = () => {
    setIsOpenCEP(false);
    setIsOpenLink(false);
    setGif(false);
    setIsOpenConsumoMinimo(false);
  };

  const handleChangeValue = (e: any) => {
    let index = 0;
    let soma = 0;
    let { value } = e.target;
    value = value.replace(/[^0-9]/g, "");

    e.target.value = value;

    const findIndex = meses.find(({ id }) => id === e.target.name);

    meses.forEach((elem) => {
      if (elem.id === findIndex?.id) {
        elem.value = value;
      }
      if (elem.value > 0) {
        soma += Math.trunc(elem.value);
        index++;
      }
      setMedia(Math.trunc(soma / index));
      if (soma > 0) {
        setCheckMedia(false);
      }
      return true;
    });
  };

  const handleChangeTelefone = useCallback((e: any) => {
    const { value } = e.target;

    if (value.length <= 14) {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
    } else {
      e.target.value = value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1");
    }
  }, []);

  const handleChangeCEP = useCallback((e: any) => {
    const { value } = e.target;
    e.target.value = value
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{3})(\d+?)$/, "$1");
  }, []);

  const prepareData = useCallback(
    (data: any) => {
      const dataDadosBancario: IData2DadosBancario = {
        formaPagamento: "Pix",
      };

      const dataEndereco: IData2Endereco = {
        CEP: data.enderecoCEP,
        estado: data.enderecoEstado,
        cidade: data.enderecoCidade,
        bairro: data.enderecoBairro,
        logradouro: data.enderecoLogradouro,
        numero: data.enderecoNumero,
        complemento: data.enderecoComplemento,
      };

      const dataPessoaFisica: IData2PessoaFisica = {
        nomeCompleto: data.pfNomeTitular,
        CPF: data.pfCPF,
        email: data.pfEmail,
        telefone: data.pfTelefone,
        dataNascimento: data.pfDataNasc,
      };

      const dataResponsavel: IData2Responsavel = {
        nomeCompleto: data.pjRespNomeTitular,
        CPF: data.pjRespCPF,
        email: data.pjRespEmail,
        telefone: data.pjRespTelefone,
        dataNascimento: data.pjDataNasc,
      };

      const dataPessoaJuridica: IData2PessoaJuridica = {
        razaoSocial: data.pjRazaoSocial,
        CNPJ: data.pjCNPJ,
        emailEmpresa: data.pjEmail,
        telefoneEmpresa: data.pjTelefone,
        responsavel: dataResponsavel,
      };

      const dataFatura: IData2Fatura = {
        faturas: [],
        concessionaria: data.concessionaria,
        numeroInstalacao: data.numeroInstalacao,
        dataVencimentoFatura: data.vencimentoFatura,
        classe: data.classe,
        subClasse: data.subGrupo,
        consumoJan: propostaDuplicada ? data.inputMes1 || "0" : meses[0].value,
        consumoFev: propostaDuplicada ? data.inputMes2 || "0" : meses[1].value,
        consumoMar: propostaDuplicada ? data.inputMes3 || "0" : meses[2].value,
        consumoAbr: propostaDuplicada ? data.inputMes4 || "0" : meses[3].value,
        consumoMai: propostaDuplicada ? data.inputMes5 || "0" : meses[4].value,
        consumoJun: propostaDuplicada ? data.inputMes6 || "0" : meses[5].value,
        consumoJul: propostaDuplicada ? data.inputMes7 || "0" : meses[6].value,
        consumoAgo: propostaDuplicada ? data.inputMes8 || "0" : meses[7].value,
        consumoSet: propostaDuplicada ? data.inputMes9 || "0" : meses[8].value,
        consumoOut: propostaDuplicada ? data.inputMes10 || "0" : meses[9].value,
        consumoNov: propostaDuplicada
          ? data.inputMes11 || "0"
          : meses[10].value,
        consumoDez: propostaDuplicada
          ? data.inputMes12 || "0"
          : meses[11].value,
      };

      const dataRepresentante: IDataRepresentante = {
        nome: NomeRepresentante,
        email: EmailRepresentante,
        CPF: CpfRepresentante,
        razao: RazaoRepresentante,
        CNPJ: CnpjRepresentante,
        codigoLink: CodigoLink,
        canal: canal,
        grupo: Grupo,
        gestor1: Gestor1,
        gestor2: Gestor2,
        gestor3: Gestor3,
        origem: Origem,
        codigoPlano: CodigoPlano,
        equipe: Equipe,
        regional: Regional,
      };

      const dataUsina: IDataUsina = {
        CRI: data.consorcio,
        usina: data.usina,
      };

      const dataForm: IData2Form = {
        tipoPessoa: pessoa,
        telefoneLigacao: data.telefoneLigacao,
        representante: dataRepresentante,
        dadosBancario: dataDadosBancario,
        endereco: dataEndereco,
        pessoaFisica: dataPessoaFisica,
        pessoaJuridica: dataPessoaJuridica,
        fatura: dataFatura,
        usina: dataUsina,
      };

      return dataForm;
    },
    [
      canal,
      pessoa,
      meses,
      CodigoLink,
      CnpjRepresentante,
      CpfRepresentante,
      EmailRepresentante,
      NomeRepresentante,
      RazaoRepresentante,
      CodigoPlano,
      Equipe,
      Gestor1,
      Gestor2,
      Gestor3,
      Grupo,
      Origem,
      Regional,
      propostaDuplicada,
    ]
  );

  const [progressIndex, setProgressIndex] = useState(0);
  const [attachments, setAttachments] = useState<File[]>([]);

  const lastIndex = useMemo(() => {
    return attachments.length + 1;
  }, [attachments]);

  const handleSubmitFormRegister = useCallback(
    async (data: any) => {
      try {
        // eslint-disable-next-line
        Ref.current?.setErrors({});
        data["average"] = media;

        let atLeastOneMonthFilled = false;
        for (let i = 0; i < meses.length; i++) {
          const value = meses[i].value;
          if (!isNaN(value) && value > 0) {
            atLeastOneMonthFilled = true;
            break;
          }
        }

        // Se nenhum mês foi preenchido, definir checkMedia como true
        if (!atLeastOneMonthFilled && !mesesPreenchidosDup) {
          setCheckMedia(true);
          return;
        }

        setLoad(true);
        setGif(true);
        const preparedData = prepareData(data);
        setDataModal(preparedData);
        api.defaults.headers.common = {
          Authorization: `bearer ${sessionStorage.getItem(
            "@ARP-Energia:token"
          )}`,
        };
        setProgressIndex(0);
        const dataStr = sessionStorage.getItem("@ARP-Energia:duplicado");
        const dataJson = dataStr ? JSON.parse(dataStr) : null;

        await api
          .post("/csp/representante/criar/card/", preparedData)
          .then(async (res) => {
            setLoad(true);
            if (res.status === 201) {
              setProgressIndex(1);

              const idCard = res.data["idCard"];
              if (idCardDuplicado) {
                api.defaults.headers.common = {
                  Authorization: `bearer ${sessionStorage.getItem(
                    "@ARP-Energia:token"
                  )}`,
                };
                await api.post(`/csp/usuario/alterar/observacao`, {
                  idCard: idCard,
                  observacao: `Proposta duplicada de ${idCardDuplicado}`,
                });
                setIdCardDuplicado("");
              }

              for (let i = 0; i < attachments.length; i++) {
                const arrayBuffer = await attachments[i].arrayBuffer();
                const extension =
                  attachments[i].name.split(".").pop() || ".undefined";
                await api.post("/csp/fatura/salvar", arrayBuffer, {
                  headers: {
                    "Content-Type": attachments[i].type,
                  },
                  params: {
                    idCard: idCard,
                    nomeArquivo: `${idCard}-${new Date().getTime()}.${extension.toLowerCase()}`,
                  },
                });
                setProgressIndex(i + 2);
              }

              setTimeout(() => {
                setLoad(false);
                setLinkRep(res.data["link"]);
                localStorage.setItem("@ARP-Energia:LastIdCard", idCard);
                setCalculo(res.data["economiaAnual"]);
                setMensalidade(res.data["mensalidade"]);
                setDetalhamento(res.data["infAdi"]);
                if (TipoVendedor === "Pós Venda") {
                  alteraCRI(res.data["idCard"], preparedData);
                }
                handleSetModal(res.data["retorno"]);
              }, 1500);
            }

            if (res.status === 200) {
              handleSetModal(res.data["retorno"]);
            }
          })
          .catch((error) => {
            setLoad(false);
            showToast("catchSalvarRegistro");
            setGif(false);
          });
        setLoad(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          // eslint-disable-next-line
          Ref.current?.setErrors(errors);

          if (errors["average"]) {
            setCheckMedia(true);
          }
        } else {
          showToast("catchSalvarRegistro");
        }
      }
      setLoad(false);
    },
    [
      setLoad,
      media,
      mesesPreenchidosDup,
      prepareData,
      meses,
      idCardDuplicado,
      attachments,
      TipoVendedor,
      handleSetModal,
      alteraCRI,
      showToast,
    ]
  );

  const handleChangeCheck = (e: any) => {
    const { value } = e.target;
    const currentValues = methods.getValues();
  
    if (!propostaDuplicada) {
      setPessoa(value);
      reset();
      return;
    }
  
    // Mantém consumo/endereço
    const camposParaManter = [
      "inputMes1", "inputMes2", "inputMes3", "inputMes4", "inputMes5", "inputMes6",
      "inputMes7", "inputMes8", "inputMes9", "inputMes10", "inputMes11", "inputMes12",
      "enderecoCEP", "enderecoEstado", "enderecoCidade", "enderecoBairro",
      "enderecoLogradouro", "enderecoNumero", "enderecoComplemento",
      "classe", "subGrupo",
    ];
  
    const dadosMantidos: Record<string, any> = {};
    camposParaManter.forEach((campo) => {
      dadosMantidos[campo] = currentValues[campo];
    });
  
    reset();
  
    const novoTipoBackup = value === "PF" ? backupPF : backupPJ;
    setTimeout(() => {
      Object.entries({ ...novoTipoBackup, ...dadosMantidos }).forEach(
        ([campo, valor]) => {
          methods.setValue(campo, valor);
        }
      );
    }, 0);
  
    setPessoa(value);
    setMesesValues(dadosMantidos);
  };
  

  const handleSanitizeEmail = useCallback(
    (e: any) => {
      const { value } = e.target;
      const sanitizedValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");

      e.target.value = sanitizedValue;

      if (sanitizedValue !== value) {
        showToast("Sanitize");
      }
    },
    [showToast]
  );

  const handleInputSanitizeAndLimit = useCallback(
    (e: any) => {
      handleSanitizeEmail(e);
    },
    [handleSanitizeEmail]
  );

  const handleCPFValidation = async (e: any) => {
    const { value } = e.target;

    if (!value.trim()) {
      methods.clearErrors("pjRespCPF");
      methods.clearErrors("pfCPF");
      return;
    }

    if (pessoa === "PF") {
      try {
        const schema = Yup.object().shape({
          pfCPF: Yup.string().test("CPF", "Informe um CPF válido", (val) =>
            val ? cpf.isValid(val.replace(/[^\d]+/g, "")) : true
          ),
        });

        const data = { pfCPF: value };

        await schema.validate(data, {
          abortEarly: false,
        });

        methods.clearErrors("pfCPF");
      } catch (error: any) {
        console.log(error.message);
        methods.setError("pfCPF", { type: "error", message: error.message });
      }
    }

    if (pessoa === "PJ") {
      try {
        const schema = Yup.object().shape({
          pjRespCPF: Yup.string().test("CNPJ", "Informe um CPF válido", (val) =>
            val ? cpf.isValid(val.replace(/[^\d]+/g, "")) : true
          ),
        });

        const data = { pjRespCPF: value };

        await schema.validate(data, {
          abortEarly: false,
        });

        methods.clearErrors("pjRespCPF");
      } catch (error: any) {
        methods.setError("pjRespCPF", {
          type: "error",
          message: error.message,
        });
      }
    }
  };

  const handleCNPJValidation = async (e: any) => {
    const { value } = e.target;

    if (!value.trim()) {
      methods.clearErrors("pjCNPJ");
      return;
    }
    try {
      const schema = Yup.object().shape({
        pjCNPJ: Yup.string().test("CNPJ", "Informe um CNPJ válido", () =>
          cnpj.isValid(value.replace(/[^\d]+/g, ""))
        ),
      });

      const data = { pjCNPJ: value };

      await schema.validate(data, {
        abortEarly: false,
      });
      methods.clearErrors("pjCNPJ");
    } catch (error: any) {
      methods.setError("pjCNPJ", { type: "error", message: error.message });
    }
  };

  const listaConsorcios = useCallback(
    async (value: any) => {
      setLoad(true);
      await api
        .get("/csp/cri/usina?concessionaria=" + value)
        .then((res: any) => {
          setCriUsina(res.data.CRIs);
          setConsorcios(
            res.data.CRIs.map((item: any) => ({
              label: String(item.codUnidade),
              value: String(item.codUnidade),
            }))
          );
        })
        .catch((err: any) => {
          setLoad(false);
          console.error(err);
          if (err.response.status === 404) {
            showToast("404Consorcio");
            setNoOptionsTextConsorcio("Não há usinas");
            setConsorcios([]);
          } else {
            setNoOptionsTextConsorcio("Selecione o a concessionária");
            setConsorcios([]);
          }
        });
      setLoad(false);
    },
    [setLoad, setNoOptionsTextConsorcio, showToast]
  );

  const handleOnChangeConsorcio = useCallback(
    (cons?: string) => {
      methods.setValue("usina", "");
      setUsinas([]);

      if (cons) {
        const opt = criUsina?.find(
          (unidade: any) => String(unidade.codUnidade) === cons
        )?.usinas;

        if (opt)
          setUsinas(
            opt.map((nome: any) => ({ label: nome.nome, value: nome.nome }))
          );
      }
    },
    [methods, criUsina]
  );

  const updateMesesCalculations = (valoresProcessados: number[]) => {
    let soma = 0;
    let index = 0;

    valoresProcessados.forEach((value) => {
      const valorTruncado = Math.trunc(value);
      if (valorTruncado > 0) {
        soma += valorTruncado;
        index++;
      }
    });

    setMedia(index > 0 ? Math.trunc(soma / index) : 0);
    if (soma > 0) {
      setCheckMedia(false);
      setMesesPreenchidosDup(true);
    }
  };

  const setMesesValues = (values: Record<string, string | number>) => {
    const valoresParaCalculo: number[] = [];

    Object.keys(values).forEach((key) => {
      if (key.startsWith("inputMes")) {
        const valorNumerico = Math.trunc(
          Number(String(values[key]).replace(/[^0-9]/g, ""))
        );
        valoresParaCalculo.push(valorNumerico);
      }
    });

    updateMesesCalculations(valoresParaCalculo);
  };

  const handleCheckDuplicated = async () => {
    await new Promise((resolve) => setTimeout(resolve, 100));
    const dataStr = sessionStorage.getItem("@ARP-Energia:duplicado");

    if (dataStr) {

      
      setPropostaDuplicada(true);
      const dataJson = JSON.parse(dataStr);
      setIdCardDuplicado(dataJson.idCard);

      setPessoa(dataJson.tipo);

      if (dataJson.tipo === "PF") {

        setBackupPF({
          pfNomeTitular: dataJson.empresa || dataJson.nome,
          pfEmail: dataJson.email,
          telefoneLigacao: dataJson.telefone_contato_para_liga_o,
          pfTelefone: dataJson.telefone_do_titular_da_conta,
          pfCPF: dataJson.cpf,
          pfDataNasc: dataJson.data_de_nascimento_do_titular
            ? dataJson.data_de_nascimento_do_titular.split("/").reverse().join("-")
            : "",
          classe: dataJson.classe,
          subGrupo: dataJson.subclasse,
          enderecoCEP: dataJson.cep,
          enderecoEstado: dataJson.estado,
          enderecoCidade: dataJson.cidade,
          enderecoBairro: dataJson.bairro,
          enderecoLogradouro: dataJson.rua,
          enderecoNumero: dataJson.n_mero,
          enderecoComplemento: dataJson.complemento,
          concessionaria: dataJson.concession_ria,
          numeroInstalacao: dataJson.n_mero_da_instala_o_cemig_1,
          vencimentoFatura: dataJson.data_de_vencimento_da_fatura_cemig,
        });

        methods.setValue("pfNomeTitular", dataJson.empresa || dataJson.nome);
        methods.setValue("pfEmail", dataJson.email);
        methods.setValue(
          "telefoneLigacao",
          dataJson.telefone_contato_para_liga_o
        );
        methods.setValue("pfTelefone", dataJson.telefone_do_titular_da_conta);
        methods.setValue("pfCPF", dataJson.cpf);

        const dataConvertida = dataJson.data_de_nascimento_do_titular
          ? dataJson.data_de_nascimento_do_titular
              .split("/")
              .reverse()
              .join("-")
          : "";

        methods.setValue("pfDataNasc", dataConvertida);
      } else if (dataJson.tipo === "PJ") {
        setBackupPJ({
          pjRazaoSocial: dataJson.empresa,
          pjEmail: dataJson.email_do_representante,
          pjTelefone: dataJson.telefone_contato_para_liga_o,
          pjCNPJ: dataJson.cnpj_do_representante_1,
          pjRespNomeTitular: dataJson.raz_o_social_do_representante_parceiro_principal,
          pjRespCPF: dataJson.vendedor_cpf,
          pjDataNasc: dataJson.data_de_nascimento_do_titular
            ? dataJson.data_de_nascimento_do_titular.split("/").reverse().join("-")
            : "",
          pjRespEmail: dataJson.email_do_representante,
          telefoneLigacao: dataJson.telefone_contato_para_liga_o,
          pjRespTelefone: dataJson.telefone_contato_para_liga_o,
          classe: dataJson.classe,
          subGrupo: dataJson.subclasse,
          enderecoCEP: dataJson.cep,
          enderecoEstado: dataJson.estado,
          enderecoCidade: dataJson.cidade,
          enderecoBairro: dataJson.bairro,
          enderecoLogradouro: dataJson.rua,
          enderecoNumero: dataJson.n_mero,
          enderecoComplemento: dataJson.complemento,
          concessionaria: dataJson.concession_ria,
          numeroInstalacao: dataJson.n_mero_da_instala_o_cemig_1,
          vencimentoFatura: dataJson.data_de_vencimento_da_fatura_cemig,
        });
        methods.setValue("pjRazaoSocial", dataJson.empresa);
        methods.setValue("pjEmail", dataJson.email);
        methods.setValue("pjTelefone", dataJson.telefone_contato_para_liga_o);
        methods.setValue("pjCNPJ", dataJson.cnpj);
        methods.setValue(
          "pjRespNomeTitular",
          dataJson.nome_do_respons_vel_legal
        );
        methods.setValue("pjRespCPF", dataJson.cpf_do_respons_vel_legal);
        const dataConvertida = dataJson.data_de_nascimento_do_titular
          ? dataJson.data_de_nascimento_do_titular
              .split("/")
              .reverse()
              .join("-")
          : "";
        methods.setValue("pjDataNasc", dataConvertida);
        methods.setValue("pjRespEmail", dataJson.email_do_respons_vel_legal);
        methods.setValue(
          "telefoneLigacao",
          dataJson.telefone_contato_para_liga_o
        );
        methods.setValue(
          "pjRespTelefone",
          dataJson.telefone_do_titular_da_conta
        );
      }
      methods.setValue("pjRazaoSocial", dataJson.empresa);
      const mesesMapping = [
        { key: "jan", inputName: "inputMes1" },
        { key: "fev", inputName: "inputMes2" },
        { key: "mar", inputName: "inputMes3" },
        { key: "abr", inputName: "inputMes4" },
        { key: "mai", inputName: "inputMes5" },
        { key: "jun", inputName: "inputMes6" },
        { key: "jul", inputName: "inputMes7" },
        { key: "ago", inputName: "inputMes8" },
        { key: "set", inputName: "inputMes9" },
        { key: "out", inputName: "inputMes10" },
        { key: "nov", inputName: "inputMes11" },
        { key: "dez", inputName: "inputMes12" },
      ];

      const isValidValue = (value: any) => {
        return value != null && value !== "" && value !== "0";
      };

      mesesMapping.forEach(({ key, inputName }) => {
        const value = dataJson[key];
        if (isValidValue(value)) {
          methods.setValue(inputName, value);
        }
      });

      const valuesToSet: Record<string, string | number> = {};
      mesesMapping.forEach(({ key, inputName }) => {
        const value = dataJson[key];
        if (isValidValue(value)) {
          valuesToSet[inputName] = value;
        }
      });

      setMesesValues(valuesToSet);

      methods.setValue("classe", dataJson.classe);
      methods.setValue("subGrupo", dataJson.subclasse);

      methods.setValue("enderecoCEP", dataJson.cep);
      handleBlurCEP(dataJson.cep);
      methods.setValue("enderecoEstado", dataJson.estado);
      methods.setValue("enderecoCidade", dataJson.cidade);
      methods.setValue("enderecoBairro", dataJson.bairro);
      methods.setValue("enderecoLogradouro", dataJson.rua);
      methods.setValue("enderecoNumero", dataJson.n_mero);
      methods.setValue("enderecoComplemento", dataJson.complemento);

      methods.setValue("concessionaria", dataJson.concession_ria);
      methods.setValue(
        "numeroInstalacao",
        dataJson.n_mero_da_instala_o_cemig_1
      );
      methods.setValue(
        "vencimentoFatura",
        dataJson.data_de_vencimento_da_fatura_cemig
      );

      sessionStorage.removeItem("@ARP-Energia:duplicado");
    }
  };

  useEffect(() => {
    handleCheckDuplicated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (propostaDuplicada) {
      setUcValidada(true);
    }
  }, [propostaDuplicada]);

  const [isValidatingUC, setIsValidatingUC] = useState(false);
  const [ucValidada, setUcValidada] = useState(propostaDuplicada);

  const validarUC = useCallback(
    async (numeroUC: string) => {
      if (propostaDuplicada || !numeroUC) {
        setUcValidada(true);
        return;
      }

      setIsValidatingUC(true);
      setUcValidada(false);

      try {
        const response = await api.get(
          `/csp/representante/consultar/uc?uc=${numeroUC}`
        );
        if (response.data?.retorno === "negado criar nova proposta") {
          setModalUcBloqueada(true);
          setUcBloqueada(true);
          setUcValidada(false);
        } else {
          setUcBloqueada(false);
          setUcValidada(true);
        }
      } catch (error) {
        setUcBloqueada(false);
        setUcValidada(false);
      } finally {
        setIsValidatingUC(false);
      }
    },
    [propostaDuplicada]
  );

  const handleValidateAndSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    if (ucBloqueada) {
      showToast("UC-bloqueada");
      return;
    }

    // Executa validações do React Hook Form e envia
    const isValid = await methods.trigger();
    if (isValid) {
      const data = methods.getValues();
      handleSubmitFormRegister(data);
    }
  };

  return (
    <>
      <Dialog
        open={modalUcBloqueada}
        onClose={() => {}}
        disableEscapeKeyDown
        aria-labelledby="uc-bloqueada-title"
        PaperProps={{
          sx: { px: 4, py: 3 },
        }}
      >
        <DialogTitle id="uc-bloqueada-title" style={{ textAlign: "center" }}>
          UC Bloqueada
        </DialogTitle>

        <DialogContent>
          <Typography style={{ textAlign: "justify" }}>
            Já existe proposta realizada para este número de instalação nos
            últimos 30 dias.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => setModalUcBloqueada(false)}
            variant="contained"
            sx={{
              backgroundColor: "#6c5af4",
              color: "#fff",
              fontWeight: "bold",
              "&:hover": {
                backgroundColor: "#5949d6",
              },
              "&:disabled": {
                backgroundColor: "#d3d3d3",
                color: "#888",
              },
            }}
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
      <ModalProgress
        isOpen={isGif}
        percent={Math.round(100 / lastIndex) * progressIndex}
      />

      <ModalCEP isOpen={modalIsOpenCEP} onRequestClose={closeModal} />
      <ModalLink
        isOpen={modalIsOpenLink}
        onRequestClose={closeModal}
        rowIdxVisual={linkRep}
        calculo={calculo}
        mensalidade={mensalidade}
        data={dataModal}
        detalhamento={detalhamento}
      />
      <ModalConsumoMinimo
        isOpen={modalIsOpenConsumoMinimo}
        onRequestClose={closeModal}
      />
      <Toast toastList={list} autoDelete={true} />

      <FormProvider {...methods}>
        <form onSubmit={handleValidateAndSubmit}>
          <DivForm>
            <Title1>
              Preencha os dados do titular da unidade consumidora:
            </Title1>
              <RadioInputContainer
                onMouseEnter={() => propostaDuplicada && setIsTooltipOpen(true)}
                onMouseLeave={() => setIsTooltipOpen(false)}
              >
                <InputLabel>
                  <input
                    id="btnRadioPF"
                    type="radio"
                    name="radio"
                    onChange={handleChangeCheck}
                    value="PF"
                    checked={
                      pessoa === "PF" || pessoa === undefined || pessoa === ""
                    }
                  />
                  Pessoa física
                </InputLabel>
                <InputLabel>
                  <input
                    id="btnRadioPJ"
                    type="radio"
                    name="radio"
                    onChange={handleChangeCheck}
                    value="PJ"
                    checked={pessoa === "PJ"}
                  />
                  Pessoa jurídica
                </InputLabel>
              </RadioInputContainer>

            <DivContainer>
              {pessoa === "PF" ? (
                <>
                  <RHFInput
                    type="text"
                    id="inputPfNomeTitular"
                    name="pfNomeTitular"
                    placeholder="Nome do titular"
                    label="Nome do titular"
                  ></RHFInput>
                  <RHFInput
                    type="text"
                    name="pfEmail"
                    id="inputPfEmail"
                    placeholder="E-mail"
                    label="E-mail"
                    maxLength={100}
                    onChange={(e: any) => handleInputSanitizeAndLimit(e)}
                  ></RHFInput>

                  <RHFInput
                    type="tel"
                    name="telefoneLigacao"
                    id="telefoneLigacao"
                    placeholder="Telefone"
                    label="Telefone"
                    onChange={handleChangeTelefone}
                    maxLength={20}
                    phone
                  ></RHFInput>

                  <RHFInput
                    type="tel"
                    name="pfTelefone"
                    id="inputPfTelefone"
                    placeholder="WhatsApp"
                    label="WhatsApp"
                    onChange={handleChangeTelefone}
                    maxLength={20}
                    phone
                  ></RHFInput>

                  <RHFInput
                    type="text"
                    name="pfCPF"
                    id="inputPfCPF"
                    placeholder="CPF"
                    label="CPF"
                    cpf
                    onBlur={handleCPFValidation}
                    maxLength={1000}
                  ></RHFInput>

                  <RHFInput
                    type="date"
                    name="pfDataNasc"
                    id="inputPfDataNasc"
                    placeholder="Data de nascimento"
                    label="Data de nascimento"
                    maxLength={1000}
                  />
                </>
              ) : pessoa === "PJ" ? (
                <>
                  <RHFInput
                    type="text"
                    id="inputPjRazaoSocial"
                    name="pjRazaoSocial"
                    placeholder="Razão Social"
                    label="Razão Social"
                    maxLength={100}
                    onLimit={() => showToast("Limite")}
                  ></RHFInput>

                  <RHFInput
                    type="text"
                    id="inputPjEmail"
                    name="pjEmail"
                    placeholder="E-mail"
                    label="E-mail"
                    maxLength={100}
                    onChange={(e: any) => handleInputSanitizeAndLimit(e)}
                  ></RHFInput>

                  <RHFInput
                    type="tel"
                    id="inputPjTelefone"
                    name="pjTelefone"
                    placeholder="Telefone ou celular"
                    label="Telefone ou celular"
                    onChange={handleChangeTelefone}
                    maxLength={1000}
                    phone
                  ></RHFInput>

                  <RHFInput
                    type="text"
                    name="pjCNPJ"
                    id="inputPjCNPJ"
                    placeholder="CNPJ"
                    label="CNPJ"
                    cpf
                    onBlur={handleCNPJValidation}
                    maxLength={18}
                  ></RHFInput>
                </>
              ) : (
                <></>
              )}
            </DivContainer>

            <Title1>Informações de consumo do lead:</Title1>
            <DivContainer>
              <DivSelect>
                <RHFAutocomplete
                  name="classe"
                  options={classes}
                  label="Classe"
                  onChange={(val) => handleOnChangeClass(val)}
                />
              </DivSelect>
              <DivSelect>
                <RHFAutocomplete
                  name="subGrupo"
                  options={grupoTarifario}
                  label="Subgrupo Tarifário"
                  noOptionsText="Selecione sua classe"
                />
              </DivSelect>
            </DivContainer>
            <Title2>Preencha o histórico de consumo dos últimos meses*:</Title2>
            <DivContainer style={{ gap: 0 }}>
              <DivBoxInput>
                {meses.map((mes, index) => (
                  <RHFInput
                    onlyNumber
                    id={mes.id}
                    name={mes.id}
                    label={mes.label}
                    type="text"
                    onChange={handleChangeValue}
                    maxLength={index === 5 ? 1000 : 6}
                    onLimit={() => showToast("Limite")}
                  />
                ))}
              </DivBoxInput>
            </DivContainer>

            {checkMedia ? (
              <DivContainer>
                <ErrorText>
                  Deve ser informado pelo menos um mês de consumo
                </ErrorText>
              </DivContainer>
            ) : (
              <></>
            )}

            {pessoa === "PJ" ? (
              <>
                <Title2>Dados do responsável legal:</Title2>
                <DivContainer>
                  <RHFInput
                    type="text"
                    name="pjRespNomeTitular"
                    id="inputPjRespNomeTitular"
                    placeholder="Nome do titular"
                    label="Nome do titular"
                    maxLength={50}
                    onLimit={() => showToast("Limite")}
                  ></RHFInput>

                  <RHFInput
                    type="text"
                    id="inputPjRespCPF"
                    name="pjRespCPF"
                    placeholder="CPF"
                    label="CPF"
                    cpf
                    onBlur={handleCPFValidation}
                    maxLength={1000}
                  ></RHFInput>

                  <RHFInput
                    type="date"
                    name="pjDataNasc"
                    id="inputPJDataNasc"
                    placeholder="Data de nascimento"
                    label="Data de nascimento"
                    maxLength={1000}
                  ></RHFInput>

                  <RHFInput
                    type="text"
                    id="inputPjRespEmail"
                    name="pjRespEmail"
                    placeholder="E-mail"
                    label="E-mail"
                    maxLength={1000}
                    onChange={(e: any) => handleInputSanitizeAndLimit(e)}
                  ></RHFInput>

                  <RHFInput
                    type="tel"
                    name="telefoneLigacao"
                    id="telefoneLigacao"
                    placeholder="Telefone"
                    label="Telefone"
                    onChange={handleChangeTelefone}
                    maxLength={20}
                    phone
                  ></RHFInput>

                  <RHFInput
                    type="tel"
                    name="pjRespTelefone"
                    id="inputPjRespTelefone"
                    placeholder="WhatsApp"
                    label="WhatsApp"
                    onChange={handleChangeTelefone}
                    maxLength={20}
                    phone
                  ></RHFInput>
                </DivContainer>
              </>
            ) : (
              <></>
            )}

            <Title2>Dados de endereço:</Title2>
            <DivContainer>
              <RHFInput
                type="text"
                id="inputEnderecoCEP"
                name="enderecoCEP"
                placeholder="CEP"
                label="CEP"
                onChange={handleChangeCEP}
                onBlur={(e) => handleBlurCEP(e.target.value)}
                maxLength={1000}
                cep
              ></RHFInput>
              <span onClick={() => disableInputCep()}>
                <RHFInput
                  type="text"
                  name="enderecoEstado"
                  id="inputEnderecoEstado"
                  placeholder="Estado"
                  label="Estado"
                  disabled
                  maxLength={1000}
                ></RHFInput>
              </span>
              <span onClick={() => disableInputCep()}>
                <RHFInput
                  type="text"
                  id="inputEnderecoCidade"
                  name="enderecoCidade"
                  placeholder="Cidade"
                  label="Cidade"
                  disabled
                  maxLength={1000}
                  onLimit={() => showToast("Limite")}
                ></RHFInput>
              </span>
              <RHFInput
                type="text"
                id="inputEnderecoBairro"
                name="enderecoBairro"
                placeholder="Bairro"
                label="Bairro"
                maxLength={75}
                onLimit={() => showToast("Limite")}
              ></RHFInput>

              <RHFInput
                type="text"
                id="inputEnderecoLogradouro"
                name="enderecoLogradouro"
                placeholder="Logradouro"
                label="Logradouro"
                maxLength={100}
                onLimit={() => showToast("Limite")}
              ></RHFInput>

              <RHFInput
                id="inputEnderecoNumero"
                name="enderecoNumero"
                placeholder="Número"
                label="Número"
                maxLength={20}
                onlyNumber
              ></RHFInput>

              <RHFInput
                type="text"
                id="inputEnderecoComplemento"
                name="enderecoComplemento"
                placeholder="Complemento"
                label="Complemento"
                maxLength={200}
                onLimit={() => showToast("Limite")}
              ></RHFInput>
            </DivContainer>
            <Title2>Selecione a concessionária:</Title2>
            <DivContainer>
              <DivSelect>
                <RHFAutocomplete
                  name="concessionaria"
                  options={concessionaria}
                  label="Selecione uma concessionária"
                  noOptionsText={noOptionsTextConcessionaria}
                  onChange={(value) => listaConsorcios(value)}
                  rules={{ required: "Informe a concessionária" }}
                />
              </DivSelect>

              <DivSelect style={{ visibility: "hidden", height: "0px" }}>
                <RHFAutocomplete name="" options={[]} label="" />
              </DivSelect>
            </DivContainer>
            <Title2>Dados da fatura:</Title2>
            <DivContainer>
              <Tooltip title="Preencha o CEP para continuar" placement={"top"}>
                <Stack sx={!canProceedToInvoiceData ? { opacity: 0.3 } : {}}>
                  <RHFInput
                    disabled={!canProceedToInvoiceData}
                    type="text"
                    name="numeroInstalacao"
                    id="inputNumeroInstalacao"
                    placeholder="Número da instalação"
                    label="Número da instalação"
                    maxLength={15}
                    onLimit={() => showToast("LimiteCaract")}
                    onlyNumber
                    onChange={() => setUcBloqueada(false)}
                    onBlur={(e) => validarUC(e.target.value)}
                  ></RHFInput>
                </Stack>
              </Tooltip>

              <RHFInput
                type="text"
                id="inputVencimentoFatura"
                name="vencimentoFatura"
                placeholder="Dia de vencimento fatura"
                onChange={onSanitizeValueDay}
                label="Dia de vencimento fatura"
                maxLength={2}
              ></RHFInput>
            </DivContainer>
            <DivContainer
              style={TipoVendedor === "Pós Venda" ? {} : { display: "none" }}
            >
              <DivSelect>
                <RHFAutocomplete
                  name="consorcio"
                  options={consorcios}
                  label="Selecionar o consórcio"
                  onChange={(val) => handleOnChangeConsorcio(val)}
                  noOptionsText={noOptionsTextConsorcio}
                />
              </DivSelect>
              <DivSelect>
                <RHFAutocomplete
                  name="usina"
                  options={usinas}
                  label="Selecionar a usina"
                  noOptionsText={"Selecione o consórcio"}
                />
              </DivSelect>
            </DivContainer>

            <Title1>Anexos da proposta</Title1>
            <Stack direction="row">
              <Box sx={{ flex: 1, overflow: "hidden" }}>
                <InputFileMultiple
                  onChange={setAttachments}
                  uploadedIndex={progressIndex - 1}
                />
              </Box>

              <Box
                sx={{ display: { xs: "none", md: "block" }, width: "1rem" }}
              />
              <Box sx={{ display: { xs: "none", md: "block" }, flex: 1 }} />
            </Stack>

            <DivButtonContainer>
              <ButtonSend
                type="submit"
                id="btnGerarARP"
                disabled={isGif || isValidatingUC || !ucValidada}
              >
                <div style={isGif ? { display: "block" } : { display: "none" }}>
                  <img
                    alt="Loading Gif"
                    src={gifLoading}
                    style={{ height: "40px", width: "40px" }}
                  />
                </div>
                <div style={isGif ? { display: "none" } : {}}>
                  Gerar proposta
                </div>
              </ButtonSend>
            </DivButtonContainer>
          </DivForm>
        </form>
      </FormProvider>
    </>
  );
};
export default GeradorDePropostas;
